// removed by extract-text-webpack-plugin
module.exports = {"documentContainer":"onfido-sdk-ui-Capture-documentContainer","faceContainer":"onfido-sdk-ui-Capture-faceContainer"};


//////////////////
// WEBPACK FOOTER
// ./components/Capture/style.css
// module id = 185
// module chunks = 1